module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa29268579a1f66a27760df06030fc70a.a2926857.png";